<template>
  <div class="orderTwo_box">
    <el-container class="order_overall">
      <el-header class="orderTwo_boxs">
        <span class="orderTwo_number">订单号:</span>
        <span class="orderTwo_number4">{{number}}</span>
        <span class="orderTwo_number2">订单状态:</span>
        <i
          v-if="this.basicForm.orderStatus > 19 && this.basicForm.orderStatus < 33 "
          class="orderTwo_icon"
        ></i>
        <i
          v-if="this.basicForm.orderStatus > 32 && this.basicForm.orderStatus < 71"
          class="orderTwo_icon2"
        ></i>
        <i v-if="this.basicForm.orderStatus == 80 " class="orderTwo_icon3"></i>
        <i v-if="this.basicForm.orderStatus == 90 " class="orderTwo_icon4"></i>
        <span class="orderTwo_number3">生成时间:</span>
        <span class="orderTwo_number4">{{this.basicForm.orderDate}}</span>
      </el-header>
      <el-main class="orderTwo_main">
        <el-tabs type="border-card" class="frame" value="first">
          <el-tab-pane class="orderTwo_orderInformation" label="订单信息" name="first">
            <el-form class="orderTwo_basic" :model="basicForm">
              <div class="orderTwo_message">基本信息</div>
              <el-row style=" text-align: left; padding-top: 32px; ">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">下单用户:</span>
                    <span class="orderTwo_typeface2">{{basicForm.creatorOrder}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">结算方式:</span>
                    <span class="orderTwo_typeface2">{{basicForm.paymentMethod}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">PP/CC:</span>
                    <span class="orderTwo_typeface2"></span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">税率:</span>
                    <span class="orderTwo_typeface2"></span>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 15px; padding-bottom: 32px;">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">销售员:</span>
                    <span class="orderTwo_typeface2">{{basicForm.salesPerson}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">销售联系方式:</span>
                    <span class="orderTwo_typeface2">{{basicForm.salesMobile}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">操作员:</span>
                    <span class="orderTwo_typeface2">{{basicForm.operator}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">操作员联系方式:</span>
                    <span class="orderTwo_typeface2">{{basicForm.operatorMobile}}</span>
                  </div>
                </el-col>
              </el-row>
            </el-form>
            <el-form class="orderTwo_basic" :model="basicForm">
              <div class="orderTwo_message interval">物流信息</div>
              <el-row style=" text-align: left; padding-top: 32px; ">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">起运港:</span>
                    <span class="orderTwo_typeface2">{{basicForm.originStation}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">目的港:</span>
                    <span class="orderTwo_typeface2">{{basicForm.destStation}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">船公司:</span>
                    <span class="orderTwo_typeface2">{{basicForm.shippingCompanyName}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">开航日:</span>
                    <span class="orderTwo_typeface2">{{basicForm.estimatedTimeDelivery}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 15px; padding-bottom: 32px;">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">航程:</span>
                    <span class="orderTwo_typeface2">{{basicForm.voyage}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">箱型/数量:</span>
                    <span class="orderTwo_typeface2">{{basicForm.containerQuantity}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">运输条款:</span>
                    <span class="orderTwo_typeface2">
                      <span v-if="basicForm.freightTerm == 10">DOOR/DOOR</span>
                      <span v-if="basicForm.freightTerm == 20">DOOR/CY</span>
                      <span v-if="basicForm.freightTerm == 30">DOOR/CFS</span>
                      <span v-if="basicForm.freightTerm == 40">CY/DOOR</span>
                      <span v-if="basicForm.freightTerm == 50">CY/CY</span>
                      <span v-if="basicForm.freightTerm == 60">CY/CFS</span>
                      <span v-if="basicForm.freightTerm == 70">CY/FO</span>
                      <span v-if="basicForm.freightTerm == 80">CY/RAMP</span>
                      <span v-if="basicForm.freightTerm == 90">CFS/RAMP</span>
                      <span v-if="basicForm.freightTerm == 100">CFS/CY</span>
                      <span v-if="basicForm.freightTerm == 110">CFS/CFS</span>
                      <span v-if="basicForm.freightTerm == 120">CFS/DOOPR</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">附加服务项:</span>
                    <span class="orderTwo_typeface2">
                      <span v-if="basicForm.additionService1 == 10">拖车;</span>
                      <span v-if="basicForm.additionService2 == 10">报关;</span>
                      <span v-if="basicForm.additionService3 == 10">内装;</span>
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 15px; ">
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">提单号:</span>
                    <span class="orderTwo_typeface2">{{basicForm.mawbNo}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple" style="width:400px">
                    <span class="orderTwo_typeface">船名航次:</span>
                    <span class="orderTwo_typeface2">{{basicForm.vesselOrVoyageNo}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">温度:</span>
                    <span class="orderTwo_typeface2"></span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <span class="orderTwo_typeface">湿度:</span>
                    <span class="orderTwo_typeface2"></span>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 15px; ">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <span class="orderTwo_typeface">通风:</span>
                    <span class="orderTwo_typeface2"></span>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 15px; ">
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <div class="orderTwo_typeface" style="float: left;padding-right: 4px;">货物描述:</div>
                    <div class="orderTwo_typeface2">{{basicForm.cargoDescribe}}</div>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 10px; ">
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <div class="orderTwo_typeface" style="float: left;padding-right: 4px;">特殊要求:</div>
                    <div class="orderTwo_typeface2">{{basicForm.specialRequirements}}</div>
                  </div>
                </el-col>
              </el-row>
              <el-row style=" text-align: left; padding-top: 10px;padding-bottom: 30px;">
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <div class="orderTwo_typeface" style="float: left;padding-right: 4px;">备注:</div>
                    <div class="orderTwo_typeface2">{{basicForm.remark}}</div>
                  </div>
                </el-col>
              </el-row>
            </el-form>
            <el-form class="orderTwo_basic interval atta" :model="basicForm">
              <div class="orderTwo_message">费用信息</div>
              <el-table
                :data="tableData"
                class="ot_text"
                style="border: 1px #EAEAEA solid; margin-top: 20px; "
              >
                <el-table-column prop="chargeName" label="费用项目" width="120"></el-table-column>
                <el-table-column prop="unit" label="计价单位" width="120"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
                <el-table-column prop="taxPrice" label="单价" width="100"></el-table-column>
                <el-table-column prop="quotationCurrency" label="币别" width="100"></el-table-column>
                <el-table-column prop="taxPoint" label="税点" width="100"></el-table-column>
                <el-table-column prop="quotaUntaxedAmount" label="合计未税金额" width="150"></el-table-column>
                <el-table-column prop="quotaTaxAmount" label="合计含税金额" width="150"></el-table-column>
              </el-table>
              <div class="sum_box">
                <div class="sum_box1">
                  <span class="sum_money">总金额</span>
                  <span class="sum_Currency">USD</span>
                  <span class="sum_untaxed">{{this.usDtotal1}}</span>
                  <span class="sum_summation">{{this.usDtotal2}}</span>
                </div>
                <div class="sum_box2">
                  <span class="sum_Currency">RMB</span>
                  <span class="sum_untaxed">{{this.rmBtotal1}}</span>
                  <span class="sum_summation">{{this.rmBtotal2}}</span>
                </div>
              </div>
            </el-form>
            <div class="orderTwo_button">
              <el-button type="primary">确认报价</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane class="orderTwo_logisticsTracking" label="物流跟踪" name="second">
            <el-form class="orderTwo_basic orderTwo_basic1">
              <div class="orderTwo_message">跟踪动态</div>
              <div
                v-if="this.statusInfo.length>0"
                class="order-status"
                style="min-height: 150px;overflow-y: auto;"
              >
                <ul class="trace-progress-bar">
                  <li
                    style="width: 11%;"
                    :class="index<=item.node? 'progress-line-active':''"
                    v-for="(item,index) in statusInfo"
                  >
                    <p class="dynamic-tracing-font">{{item.nodeName}}</p>
                    <div class="progress-info">
                      <p class="progress-p">
                        <span v-if="item.practicalTime">
                          <el-tooltip class="item" effect="dark" placement="right-start">
                            <div slot="content">计划时间: {{item.realTime}}</div>
                            <div
                              slot="content"
                              style="padding-top:5px;"
                            >实际时间: {{item.practicalTime}}</div>
                            <el-button
                              type="text"
                              style="padding:0px; color:'#333"
                              v-if="item.realTime !==item.practicalTime"
                            >变</el-button>
                          </el-tooltip>
                        </span>
                        <span class="trace-operator-name progress-dot-active">{{item.realTime}}</span>
                      </p>
                      <p :style="item.planAmount<1 || item.practicalAmount<1 ? 'display:none;':''">
                        箱数量：
                        <span
                          :style="item.practicalAmount>item.planAmount || item.practicalAmount<item.planAmount ? 'color:#539dfe':''"
                          class="ctnNum-info progress-dot-active"
                        >{{item.practicalAmount}}</span>
                        <span class="progress-dot-active">/</span>
                        <span class="ctnNum-info progress-dot-active">{{item.planAmount}}</span>
                      </p>
                    </div>
                    <span :class="index<=item.node ? 'progress-dot-active':''"></span>
                  </li>
                </ul>
              </div>
              <div
                v-if="this.statusInfo.length == 0"
                style="color: #959595;padding-top: 40px;font-family: 'SourceHanSans-Medium';"
              >暂未获取动态跟踪</div>
            </el-form>
            <el-form class="orderTwo_basic orderTwo_basic2" v-model="shipsForm">
              <div class="orderTwo_message interval">船舶计划</div>
              <el-row v-if="this.sfm.length>0" class="orderTwo_ship">
                <el-col :span="3">
                  <div class="grid-content bg-purple">船名</div>
                  <div class="ship_time">{{shipsForm.vslName}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple-light">航次</div>
                  <div class="ship_time">{{shipsForm.voy}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple">开港时间</div>
                  <div class="ship_time">{{shipsForm.cyOpenTime}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple-light">截港时间</div>
                  <div class="ship_time">{{shipsForm.cyCloseTime}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple">计划靠泊时间</div>
                  <div class="ship_time">{{shipsForm.eta}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple-light">计划离泊时间</div>
                  <div class="ship_time">{{shipsForm.etd}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple-light">实际靠泊时间</div>
                  <div class="ship_time">{{shipsForm.ata}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple-light">实际离泊时间</div>
                  <div class="ship_time">{{shipsForm.atd}}</div>
                </el-col>
              </el-row>
              <div
                v-if="this.sfm.length == 0"
                style="padding-bottom: 20px;color: #959595;padding-top: 20px;font-family: 'SourceHanSans-Medium';"
              >暂未获取船舶计划</div>
            </el-form>
            <el-form>
              <div class="orderTwo_message interval" style="padding-bottom: 20px ;">码头箱信息</div>
              <div v-if="this.shipsFormes.length> 0">
                <div style="padding-bottom: 10px;    height: 50px;">
                  <div style="display: inline;position: absolute;left: 30px;">
                    <el-button
                      @click="cartonUp"
                      class="orlan"
                      icon="el-icon-arrow-left"
                      style="position: relative;left: -10px; width:20px;"
                    ></el-button>
                  </div>
                  <div style="display: inline;position: absolute;left: 66px;">
                    <el-button
                      @click="ShippingCase(item)"
                      class="orderTwo_gaoL"
                      style="width: 98px;text-align: center;padding: 14px 0;font-size: 13px; cursor:pointer; margin-left: 5px;"
                      v-for="(item,index) in shipsFormes"
                      :key="index"
                    >{{item.containerNo}}</el-button>
                  </div>

                  <div style="display: inline;position: absolute;right: 100px;">
                    <el-button
                      @click="cartonBelow"
                      class="orran"
                      icon="el-icon-arrow-right"
                      style="position: relative;left: 80px;width:25px;"
                    ></el-button>
                  </div>
                </div>
                <div style="border: 1px #eaeaea solid; text-align: left;">
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">码头</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.terminal}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">船名航次</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.vslName}}/{{shipsForms.voy}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">场箱位</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.slot}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">进出口标识</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.ieId}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">箱号</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.containerNo}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">铅封号</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.sealNo}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">尺寸</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.cSize}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">箱型</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.cType}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">装货港</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.pol}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">卸货港</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.pod}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">中转港</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.tsp}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">目的港</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.dtp}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">箱货重</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.poundwgt}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">VGM重量</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.vgm}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">VGM签名</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.vgmSign}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">VGM称重方式</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.vgmWgtType}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">进场时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.inTime}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">出场时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.outTime}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">码头放行</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.terminalStatus}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">码头放行时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.terminalTime}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">海关放行</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.customStatus}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">海关放行时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.customTime}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">国检放行</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.inspectionStatus}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">国检放行时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.inspectionTime}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">箱动态</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.cntrdynamic}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">是否查验</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.ifci}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">查验方式</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.ciType}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">查验时间</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.ciTime}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3" class="orderTwo_bottom">
                      <div class="orderTwo_name">国际危险品码</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.dgunNo}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">冷藏温度</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.rftmp}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">超限代码</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.olid}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_name">超高</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left orderTwo_bottom">
                      <div class="orderTwo_content">{{shipsForms.oh}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="3">
                      <div class="orderTwo_name">超前</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_content">{{shipsForms.olf}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_name">后超</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_content">{{shipsForms.olb}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_name">左超</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_content">{{shipsForms.owl}}</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_name">右超</div>
                    </el-col>
                    <el-col :span="3" class="orderTwo_left">
                      <div class="orderTwo_content">{{shipsForms.owr}}</div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div
                v-if="this.shipsFormes.length == 0"
                style="padding-bottom: 50px;color: #959595;padding-top: 50px;font-family: 'SourceHanSans-Medium';"
              >暂未获取码头箱信息</div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usDtotal1: "0", //人民币总金额未税
      usDtotal2: "0", //人民币总金额含税
      rmBtotal1: "0", //美元总金额含税
      rmBtotal2: "0", //美元总金额含税
      title: [], //跟踪动态名称
      active: 2,
      number: "H171000008 ", //订单号
      time: "2020-3-4 14:08", //时间
      shipsForm: {}, //船舶计划
      shipsFormes: [], //船舶计划箱号
      shipsAggregate: [], //船舶计划总箱号
      shipsForms: {}, //船舶计划详细
      progress: [], //进度条
      basicForm: {},
      tableData: [],
      statusInfo: [], //跟踪动态
      pagination: 1,
      sfm: []
    };
  },
  mounted() {
    this.number = this.$route.params.orderNo;
    this.orderTwo();
  },
  methods: {
    orderTwo() {
      let that = this;
      let len = JSON.parse(sessionStorage.getItem("testKeys"));
      let lenww = JSON.parse(localStorage.getItem("userInfo"));
      let orderNo = JSON.parse(sessionStorage.getItem("number"));
      this.number = orderNo;
      // this.number
      //  len.roleCode
      that
        .axios({
          method: "get",
          url:
            that.apiUrl +
            "/bnwl_oms_business/api/omsOrderOrderInformation/queryOneDetails",
          timeout: 60000,
          responseType: "json",
          params: {
            roleCode: len.roleCode,
            creatorOrderCode: lenww.username,
            customerCode: lenww.customerCode,
            orderNo: orderNo
          }
        })
        .then(res => {
          this.loading = false;
          this.basicForm = res.data.data[0];
          let list = res.data.data[0].omsOrderOrderNodeList;
          if (res.data.data[0].omsBlStatusList[0]) {
            this.sfm = res.data.data[0].omsBlStatusList;
            this.shipsForm = res.data.data[0].omsBlStatusList[0];
          }
          this.shipsAggregate = res.data.data[0].omsContainerStatusList;
          this.tableData = res.data.data[0].chargeAccountDetailList;
          this.sumTransition(this.tableData);
          this.carton(0);
          let str = res.data.data[0].omsContainerStatusList[0];
          this.ShippingCase(str);
          var eee = [];
          for (var i = 0; i < list.length; i++) {
            if (list[i].isMilestone == 10) {
              eee.push(list[i]);
            }
          }
          this.zhuhuan(eee);
          this.active = eee.length;
        });
    },
    sumTransition(e) {
      var usd = [];
      var rmb = [];
      var arr = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110];
      var arrs = [
        { unit: "车" },
        { unit: "柜" },
        { unit: "吨" },
        { unit: "立方体" },
        { unit: "公里" },
        { unit: "公斤" },
        { unit: "票" },
        { unit: "货值" },
        { unit: "代收货款" },
        { unit: "机型" },
        { unit: "货位" }
      ];
      if (e && e.length > 0) {
        for (var i = 0; i < e.length; i++) {
          if (e[i].quotationCurrency == "美元") usd.push(e[i]);
          if (e[i].quotationCurrency == "人民币") rmb.push(e[i]);
        }
        for (var t = 0; t < e.length; t++) {
          for (var o = 0; o < arr.length; o++) {
            if (e[t].unit == arr[o]) {
              e[t].unit = arrs[o].unit;
            }
          }
        }
        this.tableData = e;
        if (usd.length != 0) {
          var my = 0,
            my2 = 0,
            nume = 0,
            numw = 0;
          for (var j = 0; j < usd.length; j++) {
            var num = +usd[j].quotaUntaxedAmount;
            nume += +num;
            my = nume.toFixed(2);
            var nums = +usd[j].quotaTaxAmount;
            numw += +nums;
            my2 = numw.toFixed(2);
          }
          this.usDtotal1 = my;
          this.usDtotal2 = my2;
        }
        if (rmb.length != 0) {
          var ry = 0,
            ry2 = 0,
            nume2 = 0,
            numw2 = 0;
          for (var k = 0; k < rmb.length; k++) {
            var num2 = +rmb[k].quotaUntaxedAmount;
            nume2 += +num2;
            ry = nume2.toFixed(2);
            var nums2 = +rmb[k].quotaTaxAmount;
            numw2 += +nums2;
            ry2 = numw2.toFixed(2);
          }
          this.rmBtotal1 = ry;
          this.rmBtotal2 = ry2;
        }
      } else {
        return false;
      }
    },
    // 箱号转换
    carton(e) {
      if (e > 0) {
        this.pagination = e;
      }
      var str = this.shipsAggregate;
      var arr = [];
      var s = e * 8;
      var ss = (e + 1) * 8;
      for (var i = s; i < str.length; i++) {
        if (i < ss) {
          arr.push(str[i]);
        }
      }
      this.shipsFormes = arr;
      console.log(this.shipsFormes);

      this.ShippingCase(arr[0]);
    },
    // 上一页
    cartonUp() {
      if (this.pagination > 0) {
        var str = this.pagination - 1;
        this.carton(str);
      }
    },
    // 下一页
    cartonBelow() {
      var s = this.shipsAggregate.length / 8;
      var str = this.pagination++;
      if (str < s) {
        this.carton(str);
      }
    },
    // 转换箱数据
    zhuhuan(e) {
      var OrName = [];
      for (var i = 0; i < e.length; i++) {
        OrName.push(e[i].nodeName);
        if (e[i].planTime) {
          var sss = i;
        }
      }
      this.title = OrName;
      var tFm = [];

      for (var i = 0; i < e.length; i++) {
        if (e[i].planTime) {
          // sss = i;
          var ite = e[i].planTime;
          var ites = e[i].actualTime;
          var str = ite.substring(ite.indexOf("-") + 1);
          var strs = ites.substring(ites.indexOf("-") + 1);
        } else {
          str = "";
          strs = "";
        }
        var arr = {
          node: sss,
          realTime: str,
          nodeName: e[i].nodeName,
          practicalTime: strs,
          practicalAmount: e[i].actualQuantity,
          planAmount: e[i].planQuantity
        };
        tFm.push(arr);
      }
      this.statusInfo = tFm;
      console.log(this.statusInfo);
    },

    // 船舶计划详细数据
    ShippingCase(e) {
      if (e) {
        for (var pro in e) {
          if (e[pro] == null || e[pro] == "") {
            e[pro] = "-";
          }
        }
        this.shipsForms = e;
      }
    }
  }
};
</script>

<style>
.orderTwo_box {
  height: 100%;
  width: 985px;
}
.order_overall {
  height: 100%;
  position: relative;
}
.orderTwo_boxs {
  height: 48px !important;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  border-radius: 4px;
}
.orderTwo_number {
  float: left;
  line-height: 48px;
  font-size: 15px;
  font-family: "SourceHanSans-Medium" !important;
}
.orderTwo_number2 {
  float: left;
  line-height: 48px;
  padding-left: 20px;
  font-size: 15px;
  font-family: "SourceHanSans-Medium" !important;
}
.orderTwo_number3 {
  float: left;
  line-height: 48px;
  padding-left: 30px;
  font-size: 15px;
  font-family: "SourceHanSans-Medium" !important;
}
.orderTwo_number4 {
  float: left;
  left: 10px;
  line-height: 48px;
  padding-left: 10px;
  font-size: 15px;
  font-family: "SourceHanSans-Bold" !important;
}
</style>


// WEBPACK FOOTER //
// src/views/steward/orderTwo.vue